"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const downloadjs_1 = require("./downloadjs");
const botones_1 = require("./botones");
const files_1 = require("./files");
/**Un link de descarga ya estilizado */
class DownloadLink extends React.Component {
    render() {
        return (React.createElement(botones_1.Link, { style: "link", tooltip: "Descargar", iconClass: "fa fa-download", onClick: this.props.onClick }, this.props.label));
    }
}
exports.DownloadLink = DownloadLink;
/**Link el cuál realiza la descarga del blob que se le pasa en value */
class Download extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = async () => {
            const value = this.props.value;
            if (value == null)
                return;
            const blob = typeof (value) == "string" ? files_1.base64ToBlob(value) : value;
            downloadjs_1.download(blob, this.props.label);
        };
    }
    render() {
        return (this.props.value ?
            React.createElement(DownloadLink, { label: this.props.label, onClick: this.handleClick }) :
            React.createElement("span", { style: { color: "red" } },
                React.createElement("i", { className: "fa fa-ban fa-fw" }),
                " No disponible"));
    }
}
exports.Download = Download;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/download.js
// module id = 2205
// module chunks = 0